import {Inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
 import {map, Observable} from "rxjs";
import {API_URL} from "lib-base";
import {CardNoticias} from "../../shared/interfaces/sede_electronica";


@Injectable({
  providedIn: 'root'
})
export class NoticiasRssService {

  private readonly baseUrl: string;

  constructor(@Inject(API_URL) public apiUrl: string, private http: HttpClient) {
    this.baseUrl = `${apiUrl}/api/noticias`;
  }

  getAllNoticias():Observable<CardNoticias[]> {
    return this.http.get<CardNoticias[]>(`${this.baseUrl}/public/all`).pipe(
      map(value => {
        value.map( item=> {
          if (Array.isArray(item.categories) && item.categories.length > 0) {
            item.categories = item.categories[0];
          }
        })

        return value;
      })
    );
  }

}
